export const STRING_ACCESS_TOKEN_COMPRARTODO = "accessTokenComprartodo";
export const STRING_SIDEBAR_EXPANDED_COMPRARTODO = "SIDEBAR_EXPANDED_COMPRARTODO";
export const STRING_LANGUAGE_COMPRARTODO = "languageComprartodo";
export const STRING_ID_ROL_COMPRARTODO = "idRolComprartodo";
export const STRING_ID_TIPO_USUARIO_COMPRARTODO = "idTipoUsuarioComprartodo";
export const STRING_ID_ALL = "7ad37ccf-7851-11f1-af06-e4b97aefedde";


export const STRING_TRUE = "true";
export const STRING_FALSE = "false";

export const URL = "url";
export const CHECK = "check";
export const UBICACION_GPS = "ubicacion_gps";
export const COLOR = "color";
export const ACCIONES = "acciones";
export const CORREOS = "correos";

export const STRING_TIPO_DE_IMAGEN = {
    image: "image",
    svg: "svg",
};